import { AdminApp } from './features/admin/AdminApp';
import { useAuth } from './features/auth/auth-context';
import { SignInPage } from './features/auth/SignInPage';
import { PublicBookingPage } from './features/public-booking/PublicBookingPage';
import { BookingManagementPage } from './features/public-booking/BookingManagementPage';

export function App() {
  const path = window.location.pathname;
  if (path.startsWith('/book/'))
    return <PublicBookingPage slug={decodeURIComponent(path.slice(6))} />;
  if (path === '/manage') return <BookingManagementPage />;
  return <AuthenticatedApplication />;
}

function AuthenticatedApplication() {
  const { session, loading } = useAuth();
  if (loading)
    return (
      <main className="centered">
        <p>Checking your session…</p>
      </main>
    );
  return session ? <AdminApp /> : <SignInPage />;
}
